/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../shared/colours';
import {
  GapiMeetingData, ScrollState, Page, ScrollBehavior,
} from '../../shared/types/types';
import { ALL_PAGES } from '../../utils/enums';
import { groupMeetingsByDate } from '../../utils/meetings/meetingsUtils';
import BorderRadiusContainer from '../all-pages/BorderRadiusContainer';
import AllNotesHeaderMolecule from './AllNotesHeaderMolecule';
import NotesListOrganism from './notes-list/NotesListOrganism';
import SearchbarNotes from './SearchbarNotes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative; // so that the GoToTodayButtonMolecule can be positioned absolute

  background-color: ${COLORS.gray1};
  padding: 24px 16px 24px 16px;
  height: 100%;
  border-radius: 24px 24px 0 0;
`;

const SearchContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;
  /* background: ${COLORS.surface}; */
`;

interface Props {
  page: Page;
  notes: GapiMeetingData[];
  isLoading: boolean;
  isFetchMoreMeetingsBtnEnable: boolean;
  // eslint-disable-next-line no-unused-vars
  onAction: (eventId: string, calendarId: string, startDateTime: string) => void,
  // eslint-disable-next-line no-unused-vars
  onScroll: (status: ScrollState) => void,
  // eslint-disable-next-line no-unused-vars
  onClickToday: (behavior: ScrollBehavior) => void,
  fetchMeetingsAgain: () => void;
  onClickFetchMoreMeetings: () => void;
  searchText: string,
  // eslint-disable-next-line no-unused-vars
  onSearchTextChange: (text: string) => void;
}

const AllNotesTemplate = ({
  page, notes, isLoading, isFetchMoreMeetingsBtnEnable, onAction, onScroll,
  onClickToday, fetchMeetingsAgain, onClickFetchMoreMeetings,
  searchText, onSearchTextChange,
}: Props) => {
  const groupedNotes = groupMeetingsByDate(notes);

  if (page !== ALL_PAGES.ALL_NOTES) return null;

  return (
    <BorderRadiusContainer id="AllNotesTemplate">
      <Container>
        <AllNotesHeaderMolecule
          isLoading={isLoading}
          fetchMeetingsAgain={fetchMeetingsAgain}
          onClickToday={onClickToday}
        />
        <SearchContainer>
          <SearchbarNotes text={searchText} onTextChange={onSearchTextChange} />
        </SearchContainer>
        {/* <NotesFilterBoardOrganism /> */}
        <NotesListOrganism
          groupedNotes={groupedNotes}
          isLoading={isLoading}
          onAction={onAction}
          onScroll={onScroll}
          onClickFetchMoreMeetings={onClickFetchMoreMeetings}
          isFetchMoreMeetingsBtnEnable={isFetchMoreMeetingsBtnEnable}
        />
      </Container>
    </BorderRadiusContainer>
  );
};

export default AllNotesTemplate;
